import {TechnologicalOperation} from "../../../model/technological-operation/TechnologicalOperation";
import {TechnologicalOperationFormTemplate} from "./TechnologicalOperationFormTemplate";

interface FormProps {
    data: TechnologicalOperation
}

export function TechnologicalOperationFormEdit(props: FormProps) {

    return (
        <TechnologicalOperationFormTemplate data={props.data} buttonName={"Сохранить"}/>
    )
}